var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.table && !_vm.table.$attrs.grid)?_c('q-btn',_vm._b({staticStyle:{"z-index":"1"},attrs:{"round":"","icon":"fa fa-file-excel"},on:{"click":function($event){return _vm.table.download()}}},'q-btn',_vm.$attrs,false)):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }